import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { KeycloakService } from "keycloak-angular";
import { DataService } from '../data.service';
import { environment } from 'src/environments/environment';
import { IonModal } from '@ionic/angular';
import { OAuthService } from 'angular-oauth2-oidc';
import { catchError, finalize, firstValueFrom, of, timeout } from 'rxjs';
import moment from 'moment';
import { ervenyesTema } from '../modul-tema';
import 'moment/locale/hu';

@Component({
  selector: 'app-fooldal',
  templateUrl: './fooldal.component.html',
  styleUrls: ['./fooldal.component.scss'],
})
export class FooldalComponent implements OnInit {

  feljegyzesek = []
  user$
  loginMode
  userMetadata
  uuid
  @ViewChild('feljegyzesmodal') feljegyzesmodal: IonModal;
  f
  fajlok
  /*  Melyik házi feladathoz hány melléklet tartozik. A tanár feltöltötte, a szülő
   *  viszont nem nyitotta meg, mert semmi nem árulta el, hogy van mit megnyitni –
   *  a sor ugyanúgy nézett ki, mint a többi. Ez a térkép adja a gemkapcsot. */
  haziMelleklet: any = {}
  /** A mellékletlista lekérése nem sikerült – a modál ezt kiírja, nem néma. */
  fajlokHiba = ''
  napiHelyettesitesek = []
  maiDatum = new Date().toISOString().slice(0, 10)
  currentMode = ''
  gyerekek: any[] = []
  kivGyerek = 'all'
  feljegyzesLimit = 20
  zaroBeallitas: any = null

  /* ── Tanulói órarend a főoldalon (KRÉTA-szerű napi nézet) ──
     A tanuló az órarendjét eddig külön menüben, heti naptárrácsban látta. A telefonon
     ez olvashatatlan, és nem is az a kérdés, hogy „mi lesz csütörtökön", hanem hogy
     „mi a következő órám". Ezért a főoldalon napra bontva, listában mutatjuk. */
  orarendOktazon: string | null = null
  orarendGyerekek: any[] = []      // a gondviselő gyermekei (a tanulónál üres)
  private orarendKeres = ''         // a legutóbb indított órarend-kérés kulcsa
  orarendLathato = true            // a gondviselő elrejtheti (fooldal_beallitas)
  orarendCsengetes: any[] = []
  orarendOrak: any[] = []
  orarendNap = moment().format('YYYY-MM-DD')
  orarendToltodik = false
  orarendHiba = ''
  /*  Nem tanórai célú foglalkozások (korrepetálás, napközi, szakkör) a kiválasztott gyermeknél:
   *  a kiszolgáló alapból kihagyja őket, és megmondja, van-e ilyen, látszanak-e, és a belépő
   *  (csak a gondviselő) bekapcsolhatja-e. */
  orarendNemTanorai: { van: boolean; lathato: boolean; rejtett: number; modosithato: boolean } | null = null

  /*  NÁLAM LÉVŐ ESZKÖZÖK.
   *  A kölcsönzést eddig csak az adminisztrátor látta – aki elvitte a gépet, csak
   *  akkor tudta, mikorra kell visszahoznia, ha szóltak neki. A kezdőlapon mindenki
   *  látja a sajátját (a gondviselő a gyermekéét), és azt is, ha késik. */
  eszkozok: any[] = []

  constructor(public oauth: OAuthService, private data: DataService, private http: HttpClient, private router: Router) { }

  get gyerekValasztoOpcio(): any[] {
    return [
      { oktazon: 'all', name: 'Minden gyermek' },
      ...(this.gyerekek || []),
    ];
  }

  get szurtFeljegyzesek(): any[] {
    const lista = Array.isArray(this.feljegyzesek) ? this.feljegyzesek : [];
    const lathatoLista = this.loginMode === 'gondviselo'
      ? lista.filter((item: any) => this.isFeljegyzesLathato(item))
      : lista;

    if (this.loginMode !== 'gondviselo' || this.kivGyerek === 'all') return lathatoLista;

    return lathatoLista.filter((item: any) => this.feljegyzesGyermekhezTartozik(item));
  }

  get lathatoFeljegyzesek(): any[] {
    return this.szurtFeljegyzesek.slice(0, this.feljegyzesLimit);
  }

  get vanTovabbiFeljegyzes(): boolean {
    return this.szurtFeljegyzesek.length > this.feljegyzesLimit;
  }

  isSulinformMode(): boolean {
    return String(this.currentMode || '').toUpperCase() === 'SULINFORM';
  }

  canViewDailySubstitutions(): boolean {
    if (!this.isSulinformMode()) return false;

    const values = [
      this.userMetadata?.department,
      this.userMetadata?.munkakor,
      this.userMetadata?.jogkor,
      this.userMetadata?.department?.jogkor,
    ]
      .flatMap((value: any) => Array.isArray(value) ? value : [value])
      .filter(Boolean)
      .map((value: any) => String(value).trim().toLowerCase());

    return values.some(value =>
      [
        'admin',
        'ig',
        'igh',
        'igazgató',
        'igazgato',
        'igazgatóhelyettes',
        'igazgatohelyettes',
        'igazgató helyettes',
        'igazgato helyettes',
      ].includes(value)
    );
  }

  async loadDailySubstitutions() {
    const sajatIntezmeny = await this.data.getFromStorage("sajatIntezmeny");
    const intezmenyId = this.userMetadata?.intezmenyadatok?.intezmenyId || sajatIntezmeny?.intezmenyId;

    if (!this.canViewDailySubstitutions() || !intezmenyId) {
      this.napiHelyettesitesek = [];
      return;
    }

    this.http.get<any[]>(
      '/api/orarend/helyettesites/nap/' + this.maiDatum + '/' + intezmenyId
    ).pipe(
      catchError((error) => {
        console.error('daily substitutions error', error);
        return of([]);
      }),
    ).subscribe((response: any[]) => {
      this.napiHelyettesitesek = Array.isArray(response) ? response : [];
    });
  }

  async loadGyerekek() {
    const sajatIntezmeny = await this.data.getFromStorage("sajatIntezmeny");
    const intezmenyId = this.userMetadata?.intezmenyadatok?.intezmenyId || sajatIntezmeny?.intezmenyId;
    if (!this.user$?.username || !intezmenyId) return;

    this.http
      .get<any[]>(`/api/nyilvantartas/szulogyereke/${this.user$.username}/${intezmenyId}`)
      .pipe(
        catchError((error) => {
          console.error('Gyermeklista lekérési hiba:', error);
          return of([]);
        })
      )
      .subscribe((response: any[]) => {
        this.gyerekek = Array.isArray(response) ? response : [];
      });
  }

  async loadZaroBeallitas() {
    const sajatIntezmeny = await this.data.getFromStorage("sajatIntezmeny");
    const intezmenyId = this.userMetadata?.intezmenyadatok?.intezmenyId || sajatIntezmeny?.intezmenyId;
    if (!intezmenyId) return;

    this.http
      .get<any>(`/api/ertekeles-zaro/beallitas/${String(intezmenyId).replace(/^\/+|\/+$/g, '')}`)
      .pipe(
        catchError((error) => {
          console.error('Záróértékelés láthatóság betöltési hiba:', error);
          return of(null);
        })
      )
      .subscribe((response: any) => {
        this.zaroBeallitas = response || null;
      });
  }

  async ngOnInit() {
    await this.oauth.loadUserProfile();
    this.user$ = this.data.belepoKilet(this.oauth.getIdentityClaims());
    this.loginMode = await this.data.getFromStorage("loginmode")
    this.currentMode = await this.data.getFromStorage("currentMode")
    // A Könyvelés (NAPLO) kezdőlapja a modul saját főmenüje – az iskolai kezdőlap ott üres lenne.
    if (this.currentMode === 'NAPLO') { this.router.navigateByUrl('/naplo', { replaceUrl: true }); return; }
    // A Tárgyi eszköz modulnak is a saját kerete a kezdőlapja (eszközlista).
    if (this.currentMode === 'ESZKOZ') { this.router.navigateByUrl('/eszkoz', { replaceUrl: true }); return; }
    // A Számlázónak is a saját kerete a kezdőlapja.
    if (this.currentMode === 'SZAMLAZO') { this.router.navigateByUrl('/szamlazo', { replaceUrl: true }); return; }
    if (this.currentMode === 'INVENTARIO') { this.router.navigateByUrl('/inventario', { replaceUrl: true }); return; }
    if (this.currentMode === 'GEPJARMU') { this.router.navigateByUrl('/gepjarmu', { replaceUrl: true }); return; }
    // Fókusz témában a Bér kezdőlapja is a saját modulja (bal sáv nélkül itt zsákutca lenne).
    if (this.currentMode === 'BER') {
      const si: any = await this.data.getFromStorage('sajatIntezmeny');
      if (ervenyesTema(si?.intezmenyId, 'BER', si?.mode_tema) === 'fokusz') { this.router.navigateByUrl('/ber', { replaceUrl: true }); return; }
    }

    this.userMetadata = (await this.data.getFromStorage("userMetadata"))
    await this.loadDailySubstitutions();
    //this.userMetadata.department = "rendszergazda"
    this.uuid = this.user$.username
    if (this.loginMode == "gondviselo") {
      this.loadGyerekek();
      this.loadZaroBeallitas();
    }
    if (this.loginMode == "tanulo") this.orarendInditas();
    if (this.loginMode == "gondviselo") {
      await this.fooldalBeallitasBetolt();
      if (this.orarendLathato) this.orarendInditas();
    }
    this.eszkozokBetoltes();
    this.loadFeljegyzesek();
    if (this.loginMode == "gondviselo" || this.loginMode == "tanulo") this.digitalisMunkarendBetoltes();
  }

  /* ── Tantermen kívüli, digitális munkarend (backend: digitalis-munkarend.js) ──
   *  A gyermek (vagy a tanuló saját) osztályát érintő mai és jövőbeli elrendelt időszakok. A kört a
   *  kiszolgáló állapítja meg a tokenből; üres lista esetén a kártya nem jelenik meg. */
  digitalisMunkarend: any[] = [];

  async digitalisMunkarendBetoltes() {
    const sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    const intezmenyId = String(this.userMetadata?.intezmenyadatok?.intezmenyId || sajatIntezmeny?.intezmenyId || '')
      .replace(/^\/+|\/+$/g, '');
    if (!intezmenyId) return;
    this.http
      .get<any[]>(`/api/digitalis-munkarend/sajat/${encodeURI(intezmenyId)}`)
      .pipe(timeout(15_000), catchError(() => of([])))
      .subscribe((r: any) => { this.digitalisMunkarend = Array.isArray(r) ? r : []; });
  }

  /** Ma digitális munkarend van-e az adott tételben. */
  dmMa(x: any): boolean {
    const ma = new Date().toLocaleDateString('sv-SE');
    return !!x && x.tol <= ma && ma <= x.ig;
  }

  /* ── Nálam lévő eszközök ── */

  async eszkozokBetoltes() {
    const sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    const intezmenyId = this.userMetadata?.intezmenyadatok?.intezmenyId || sajatIntezmeny?.intezmenyId;
    if (!this.user$?.username || !intezmenyId) return;
    this.http
      .get<any>(`/api/laptop/sajat/${encodeURIComponent(this.user$.username)}/${intezmenyId}`)
      .pipe(timeout(15_000), catchError(() => of({ tetelek: [] })))
      .subscribe((valasz: any) => {
        // Csak a KINT lévő eszközök érdekesek; a visszahozott sorok a nyilvántartásé.
        this.eszkozok = (Array.isArray(valasz?.tetelek) ? valasz.tetelek : [])
          .filter((e: any) => !e.visszahozva);
      });
  }

  /* ── Tanulói órarend ── */

  get orarendHete(): any[] {
    const het = moment(this.orarendNap).startOf('isoWeek');
    return Array.from({ length: 7 }, (_, i) => {
      const d = het.clone().add(i, 'day');
      return {
        datum: d.format('YYYY-MM-DD'),
        nev: d.format('ddd'),
        szam: d.format('D'),
        ma: d.isSame(moment(), 'day'),
        hetvege: d.isoWeekday() > 5,
      };
    });
  }

  get orarendNapCime(): string {
    return moment(this.orarendNap).format('YYYY. MMMM D., dddd');
  }

  // A kiválasztott nap órái, óraszám szerint. A hosszabb (2 órás) óra egy sor marad:
  // az órarend soronként egy tanórát tárol, a hossz csak az idejét nyújtja.
  get orarendNapOrai(): any[] {
    return (this.orarendOrak || [])
      .filter((o: any) => moment(o.datum).format('YYYY-MM-DD') === this.orarendNap)
      .sort((a: any, b: any) => Number(a.ora) - Number(b.ora));
  }

  private async orarendInditas() {
    moment.locale('hu');
    const sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    const intezmenyId = this.userMetadata?.intezmenyadatok?.intezmenyId || sajatIntezmeny?.intezmenyId;
    if (!this.user$?.username || !intezmenyId) return;

    // A tanuló saját sora a „gyermeklistából" jön (rokonsag = saját) – ugyanaz a
    // forrás, mint a szülőnél, csak itt egyetlen sor: ő maga.
    this.http.get<any[]>(`/api/nyilvantartas/szulogyereke/${this.user$.username}/${intezmenyId}`)
      .pipe(catchError(() => of([])))
      .subscribe((rows: any[]) => {
        //  A felügyeleti jogot nem gyakorló szülő (felugyeleti_jog jelölés) az órarendet nem látja.
        const lista = (Array.isArray(rows) ? rows : []).filter((g: any) => g?.oktazon && !g?.felugyeleti_jog);
        if (this.loginMode === 'gondviselo') {
          /*  GONDVISELŐ: a gyermekei közül választ. Aki már nem jár az iskolába (nincs élő
           *  besorolása), annak nincs órarendje – ha van élő besorolású gyermek, csak őket
           *  kínáljuk. A legutóbb választott gyermek marad kiválasztva. */
          const jarok = lista.filter((g: any) => g?.aktualis_osztaly_id || g?.osztaly_id);
          this.orarendGyerekek = jarok.length ? jarok : lista;
          const emlek = this.orarendGyerekEmlek();
          const valasztott = this.orarendGyerekek.find((g: any) => String(g.oktazon) === emlek)
            || this.orarendGyerekek[0];
          this.orarendOktazon = valasztott ? String(valasztott.oktazon) : null;
        } else {
          const sajat = this.data.sajatTanulo(lista);
          this.orarendOktazon = sajat?.oktazon || lista[0]?.oktazon || null;
        }
        if (this.orarendOktazon) this.orarendHetBetoltes();
      });

    this.data.getCsengetes(moment().format('YYYY'), intezmenyId)
      .pipe(catchError(() => of([])))
      .subscribe((rows: any) => { this.orarendCsengetes = Array.isArray(rows) ? rows : []; });
  }

  private orarendHetBetoltes() {
    const intezmenyId = this.userMetadata?.intezmenyadatok?.intezmenyId;
    this.data.getFromStorage('sajatIntezmeny').then((sajatIntezmeny: any) => {
      const int = intezmenyId || sajatIntezmeny?.intezmenyId;
      if (!int || !this.orarendOktazon) return;
      const nap = moment(this.orarendNap);
      // A kérés a kérés PILLANATÁBAN kiválasztott gyermekre és hétre szól: ha közben
      // a gondviselő átváltott, a későn érkező régi válasz nem írhatja felül az újat.
      const kert = `${this.orarendOktazon}|${nap.isoWeekYear()}|${nap.isoWeek()}`;
      this.orarendKeres = kert;
      this.orarendToltodik = true;
      this.orarendHiba = '';
      this.http
        .get<any>(`/api/orarend/gondviselo/${this.user$.username}/${this.orarendOktazon}/`
          + `${nap.isoWeekYear()}/${nap.isoWeek()}/${int}`)
        .pipe(
          timeout(15_000),
          catchError((err) => {
            console.error('Órarend lekérési hiba:', err);
            if (this.orarendKeres === kert) this.orarendHiba = 'Az órarend most nem érhető el.';
            return of({ orak: [] });
          }),
          finalize(() => { if (this.orarendKeres === kert) this.orarendToltodik = false; }),
        )
        .subscribe((valasz: any) => {
          if (this.orarendKeres !== kert) return;
          this.orarendOrak = Array.isArray(valasz?.orak) ? valasz.orak : [];
          this.orarendNemTanorai = valasz?.nem_tanorai || null;
        });
    });
  }

  /** A főoldal személyes beállításai. Ha nem érhető el, az alapérték (látszik) marad. */
  private async fooldalBeallitasBetolt() {
    if (!this.user$?.username) return;
    try {
      const b: any = await firstValueFrom(this.http
        .get(`/api/fooldal-beallitas/${encodeURIComponent(this.user$.username)}`)
        .pipe(timeout(8_000), catchError(() => of(null))));
      if (b && typeof b.orarend_lathato === 'boolean') this.orarendLathato = b.orarend_lathato;
    } catch { /* alapérték marad */ }
  }

  async orarendLathatoValt(lathato: boolean) {
    const elozo = this.orarendLathato;
    this.orarendLathato = !!lathato;
    // Bekapcsoláskor most töltjük be – elrejtve le sem kértük.
    if (this.orarendLathato && !this.orarendGyerekek.length) this.orarendInditas();
    try {
      await firstValueFrom(this.http.put(
        `/api/fooldal-beallitas/${encodeURIComponent(this.user$.username)}`, { orarend_lathato: this.orarendLathato }));
      if (!this.orarendLathato) {
        this.data.sendToast('Az órarend elrejtve. A főoldalon lévő kapcsolóval bármikor visszakapcsolhatod.', 'success');
      }
    } catch (e: any) {
      this.orarendLathato = elozo;
      this.data.sendToast(e?.error?.error || 'A beállítás nem menthető – próbáld újra.', 'error');
    }
  }

  /**
   *  A nem tanórai foglalkozások ki-bekapcsolása a kiválasztott gyermekre. A beállítás a
   *  GYERMEKÉ (nem a főoldalé): a Gyermek órarendje oldalon és a gyermek saját belépésén is
   *  érvényes.
   */
  async orarendNemTanoraiValt(lathato: boolean) {
    const allapot = this.orarendNemTanorai;
    const oktazon = this.orarendOktazon;
    if (!allapot || !oktazon || !this.user$?.username || !!lathato === !!allapot.lathato) return;
    const elozo = allapot.lathato;
    allapot.lathato = !!lathato;
    try {
      await firstValueFrom(this.http.put(
        `/api/nem-tanorai/${encodeURIComponent(this.user$.username)}/${encodeURIComponent(oktazon)}`,
        { lathato: !!lathato }));
      this.orarendHetBetoltes();
    } catch (e: any) {
      allapot.lathato = elozo;
      this.data.sendToast(e?.error?.error || 'A beállítás nem menthető – próbáld újra.', 'error');
    }
  }

  /** Név és osztály a választóban – azonos keresztnevű testvéreknél az osztály dönt. */
  orarendGyerekCimke(g: any): string {
    const nev = String(g?.name || g?.full_name || '').trim() || String(g?.oktazon || '');
    const osztaly = String(g?.aktualis_osztaly || g?.osztaly || '').trim();
    return osztaly ? `${nev} (${osztaly})` : nev;
  }

  orarendGyerekValt(oktazon: any) {
    const uj = String(oktazon ?? '');
    if (!uj || uj === this.orarendOktazon) return;
    this.orarendOktazon = uj;
    this.orarendOrak = [];
    this.orarendNemTanorai = null;
    try { localStorage.setItem(this.orarendGyerekKulcs(), uj); } catch { /* privát mód: nem emlékszünk */ }
    this.orarendHetBetoltes();
  }

  private orarendGyerekKulcs(): string { return `fooldal-orarend-gyerek:${this.user$?.username || ''}`; }
  private orarendGyerekEmlek(): string {
    try { return localStorage.getItem(this.orarendGyerekKulcs()) || ''; } catch { return ''; }
  }

  orarendNapValt(datum: string) {
    const regiHet = moment(this.orarendNap).isoWeek();
    this.orarendNap = datum;
    // Hetet csak akkor töltünk újra, ha tényleg átléptünk – a napváltás a meglévő
    // heti adatból dolgozik, hogy ne legyen felesleges kérés minden koppintásra.
    if (moment(datum).isoWeek() !== regiHet) this.orarendHetBetoltes();
  }

  orarendHetLep(irany: number) {
    this.orarendNap = moment(this.orarendNap).add(irany, 'week').format('YYYY-MM-DD');
    this.orarendHetBetoltes();
  }

  orarendMa() {
    const regiHet = moment(this.orarendNap).isoWeek();
    this.orarendNap = moment().format('YYYY-MM-DD');
    if (moment().isoWeek() !== regiHet) this.orarendHetBetoltes();
  }

  // Az óra kezdete/vége a csengetési rendből. Ha nincs rögzítve, csak az óraszám marad.
  orarendIdoKezdes(ora: any): string {
    const sor = (this.orarendCsengetes || [])
      .find((x: any) => Number(x?.oraszam ?? x?.ora) === Number(ora?.ora));
    return sor?.kezdes ? String(sor.kezdes).slice(0, 5) : '';
  }

  orarendIdoVege(ora: any): string {
    const sor = (this.orarendCsengetes || [])
      .find((x: any) => Number(x?.oraszam ?? x?.ora) === Number(ora?.ora));
    return sor?.vege ? String(sor.vege).slice(0, 5) : '';
  }

  // Az óra „hol" sora: terem, és csoportóránál a csoport neve (az osztályé fölösleges,
  // azt a tanuló magától tudja).
  orarendHol(ora: any): string {
    return [ora?.terem, ora?.csoport_nev].filter(Boolean).join(' · ');
  }

  /*  A tantárgy SZÍNE. A KRÉTA-nézet ereje, hogy a napot ránézésre olvasod: ehhez a
   *  tantárgy mindig ugyanazt a színt kapja. Nem tárolunk hozzá semmit – a névből
   *  számoljuk, így új tantárgynál sincs teendő, és mindenkinél ugyanaz. */
  orarendSzin(ora: any): string {
    const paletta = ['#4a90d9', '#e8b427', '#59b36b', '#d9694a', '#8a6bd1', '#3fb0b0', '#c25b8f', '#7b8a3f'];
    const nev = String(ora?.tantargy || ora?.tantargyid || '?');
    let h = 0;
    for (let i = 0; i < nev.length; i++) h = (h * 31 + nev.charCodeAt(i)) >>> 0;
    return paletta[h % paletta.length];
  }

  /* ── Feljegyzések ── */

  feljegyzesekToltodik = false;
  feljegyzesekHiba = '';

  /**
   *  A feljegyzések betöltése a HÁTTÉRBEN, a többi kártyától függetlenül.
   *
   *  Korábban ez teljes képernyős, blokkoló töltőablakkal ment, a szülői ágon
   *  ráadásul hibaág és időkorlát NÉLKÜL: ha a forrás nem válaszolt, a
   *  `hideLoading()` sosem futott le, és az egész főoldal a pörgő ablak mögött
   *  ragadt. Most a kártyán belül van a jelzés, a hiba látszik és újrapróbálható,
   *  a főoldal többi része pedig azonnal használható.
   *
   *  A forrás a saját backend (`/api/feljegyzesek`), nem az n8n webhook: ott a
   *  lekérdezésbe be volt drótozva egy görgő 1 hónapos ablak, ezért a tanév
   *  korábbi bejegyzései eltűntek, a munkafolyamat pedig nincs verziókövetve.
   */
  /**
   *  Melyik házi feladathoz van feltöltött fájl?
   *
   *  Egyetlen kéréssel, a folyam betöltése után. Ha nem sikerül, a lista ugyanúgy
   *  használható marad – csak a gemkapocs nem jelenik meg.
   */
  private async haziMellekletekBetolt() {
    const tanorak = (Array.isArray(this.feljegyzesek) ? this.feljegyzesek : [])
      .filter((f: any) => f?.db === 'hazi' && f?.tanora)
      .map((f: any) => String(f.tanora));
    if (!tanorak.length) { this.haziMelleklet = {}; return; }
    try {
      this.haziMelleklet = await firstValueFrom(this.http.post<any>('/api/hazifiles/tobb', {
        tanorak: [...new Set(tanorak)], intezmeny: await this.intezmenyAzonosito(),
      }).pipe(timeout(20_000), catchError(() => of({})))) || {};
    } catch (e) { this.haziMelleklet = {}; }
  }

  /** Hány melléklet tartozik ehhez a sorhoz (0 = nincs). */
  mellekletDb(f: any): number {
    return f?.db === 'hazi' ? (Number(this.haziMelleklet?.[String(f?.tanora)]) || 0) : 0;
  }

  /*  Az intézmény azonosítója. A dolgozónak van „saját intézménye", a szülőnek nem
   *  feltétlenül – üresen hagyva a kiszolgáló a TANÓRÁBÓL állapítja meg, melyik
   *  iskoláé a fájl. */
  private async intezmenyAzonosito(): Promise<string> {
    const sajat = await this.data.getFromStorage('sajatIntezmeny');
    return String(sajat?.intezmenyId || this.userMetadata?.intezmenyadatok?.[0]?.intezmenyId || '');
  }

  loadFeljegyzesek() {
    if (!this.uuid) return;

    //  A tanuló a saját folyamát kéri: eddig dolgozóként ment a kérés, így a jegyei és a
    //  házi feladatai helyett a (nem létező) helyettesítéseit kapta – üres kártyát.
    const parameter = this.loginMode === 'gondviselo' ? 'szulo'
      : (this.loginMode === 'tanulo' ? 'tanulo' : 'dolgozo');
    this.feljegyzesekToltodik = true;
    this.feljegyzesekHiba = '';

    this.http
      .get<any[]>(`/api/feljegyzesek?${parameter}=${encodeURIComponent(this.uuid)}`)
      .pipe(
        timeout(15_000),
        catchError((err) => {
          console.error('feljegyzes error/timeout', err);
          this.feljegyzesekHiba = 'A feljegyzések most nem érhetők el.';
          return of([]);
        }),
        // MINDIG lefut: siker, hiba, időtúllépés és leiratkozás esetén is.
        finalize(() => { this.feljegyzesekToltodik = false; }),
      )
      .subscribe((response: any) => {
        this.feljegyzesek = Array.isArray(response) ? response : [];
        //  A gemkapocs a lista megjelenése UTÁN kerül ki – ne várakoztassa a folyamot.
        this.haziMellekletekBetolt();
      });
  }

  onFooldalGyerekValtozas(event: any) {
    this.kivGyerek = event?.oktazon ?? event ?? 'all';
    this.feljegyzesLimit = 20;
  }

  tovabbiFeljegyzesekBetoltese() {
    this.feljegyzesLimit += 20;
  }

  feljegyzesGyermekhezTartozik(item: any): boolean {
    if (!item || this.kivGyerek === 'all') return true;

    const kivGyerek = String(this.kivGyerek || '').trim();
    const direktMezok = [
      item.oktazon,
      item.tanulo,
      item.tanulo_oktazon,
      item.tanuloOktatasiAzonosito,
      item.gyermek_oktazon,
      item.gyermekOktazon,
      item.diak,
    ].map((value) => String(value ?? '').trim());

    if (direktMezok.some((value) => value === kivGyerek || value.includes(kivGyerek))) return true;

    const gyerek = (this.gyerekek || []).find((g: any) => String(g?.oktazon) === kivGyerek);
    const nevek = [
      gyerek?.name,
      gyerek?.full_name,
      `${gyerek?.viselt_vez || ''} ${gyerek?.viselt_ker || ''}`,
      `${item?.dvez || ''} ${item?.dker || ''}`,
    ].map((value) => this.normalizal(value)).filter(Boolean);

    const teljesSzoveg = this.normalizal(Object.values(item || {}).join(' '));
    const gyerekNevek = nevek.filter((value) => value !== this.normalizal(`${item?.dvez || ''} ${item?.dker || ''}`));
    return gyerekNevek.some((nev) => teljesSzoveg.includes(nev));
  }

  normalizal(value: any): string {
    return String(value ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  isFeljegyzesLathato(item: any): boolean {
    if (!item) return false;

    if (this.isEvvegiZaroFeljegyzes(item)) {
      return this.isZaroLathato('evvegi');
    }

    if (this.isFeleviZaroFeljegyzes(item)) {
      return this.isZaroLathato('felevi');
    }

    return true;
  }

  isZaroLathato(tipus: 'felevi' | 'evvegi'): boolean {
    const key = tipus === 'felevi' ? 'felevi_lathato_tol' : 'evvegi_lathato_tol';
    const datum = this.zaroBeallitas?.[key];
    if (!datum) return true;

    const tol = moment(datum);
    return tol.isValid() ? moment().isSameOrAfter(tol, 'day') : true;
  }

  isFeleviZaroFeljegyzes(item: any): boolean {
    const modja = String(item?.modja ?? item?.ertekeles_modja ?? item?.ertekelesModja ?? '').trim();
    if (modja === '2') return true;

    const text = this.feljegyzesZaroText(item);
    return text.includes('felev');
  }

  isEvvegiZaroFeljegyzes(item: any): boolean {
    const modja = String(item?.modja ?? item?.ertekeles_modja ?? item?.ertekelesModja ?? '').trim();
    if (modja === '3') return true;

    const text = this.feljegyzesZaroText(item);
    return text.includes('ev vegi')
      || text.includes('evvegi')
      || text.includes('ev vege');
  }

  private feljegyzesZaroText(item: any): string {
    return this.normalizal([
      item?.tipus,
      item?.tipusNev,
      item?.tipus_nev,
      item?.ertnev,
      item?.tema,
      item?.szoveg,
      item?.kategoria,
      item?.cim,
    ].join(' '));
  }

  close() {
    this.feljegyzesmodal.dismiss()
  }
  async openFeljegyzes(f) {
    this.f = f
    this.fajlok = []
    this.fajlokHiba = ''
    if (!f?.tanora) { this.feljegyzesmodal.present(); return; }

    await this.data.showLoading('Melléklet letöltése...')
    /*  Az intézményt üresen is hagyhatjuk: a kiszolgáló a TANÓRÁBÓL állapítja meg,
     *  melyik iskola mappájában keresse. Korábban a kliens tippelt, és ha nem
     *  találta el, a szülő üres listát kapott arra a házi feladatra, amihez a
     *  tanár fájlt töltött fel. */
    const intezmenyId = await this.intezmenyAzonosito();
    this.http
      .get('/api/hazifiles?tanora=' + encodeURIComponent(f.tanora)
        + '&intezmeny=' + encodeURIComponent(intezmenyId))
      .pipe(timeout(20_000))
      .subscribe({
        next: (response) => {
          this.fajlok = Array.isArray(response) ? response : []
          this.data.hideLoading()
          this.feljegyzesmodal.present()
        },
        /*  A HIBA SEM MARADHAT NÉMA. Eddig a modál ilyenkor meg sem nyílt, és a
         *  „Melléklet letöltése…" felirat ott maradt a képernyőn – a felhasználó
         *  számára úgy nézett ki, mintha a rendszer lefagyott volna. */
        error: (error) => {
          console.error('Házi feladat mellékletei:', error);
          this.fajlokHiba = 'A mellékletek most nem érhetők el. Próbáld újra később.'
          this.data.hideLoading()
          this.feljegyzesmodal.present()
        },
      });
  }

  /** Kép-e a melléklet – ilyenkor helyben megmutatjuk, nem csak a nevét írjuk ki. */
  kepE(file: any): boolean {
    return /\.(jpe?g|png|gif|webp|bmp|heic)$/i.test(String(file?.name || ''));
  }

  /**
   *  A melléklet címe.
   *
   *  A tárolt név szóközt és ékezetet is tartalmazhat („5. z nyelvtan házi.jpg"),
   *  ezért szakaszonként kódoljuk — a perjelek maradnak útvonal-elválasztónak.
   *  Natív alkalmazásban a relatív cím nem a kiszolgálóra mutatna, ezért ott a
   *  teljes cím kell (a kép `src`-jéhez nincs köztes réteg, ami kiegészítené).
   */
  fajlUrl(key: string): string {
    const ut = '/api/file/' + String(key || '').split('/').map(encodeURIComponent).join('/');
    const eredet = (environment.apiOrigin || '').replace(/\/api\/?$/, '').replace(/\/$/, '');
    return eredet ? eredet + ut : ut;
  }

  openLink(key) {
    // Weben új fül, natíven beépített néző (tokennel letöltött blob).
    this.data.megnyitFajl(this.fajlUrl(key), 'Fájl');
  }

}
